import type { TFunction } from 'i18next';

const PLURAL_KEYS = {
    zero: 'vks_request_zero',
    one: 'vks_request_one',
    two: 'vks_request_two',
    few: 'vks_request_few',
    many: 'vks_request_many',
    other: 'vks_request_other',
} as const satisfies Record<Intl.LDMLPluralRule, string>;

type WaitingRequestsPluralKey = (typeof PLURAL_KEYS)[keyof typeof PLURAL_KEYS];

export const getWaitingRequestsCountLabel = (t: TFunction, count: number, language: string): string => {
    const locale = language.startsWith('ru') ? 'ru-RU' : 'en-US';
    const rule = count === 0 ? 'zero' : new Intl.PluralRules(locale).select(count);
    const key = (PLURAL_KEYS[rule] ?? PLURAL_KEYS.other) as WaitingRequestsPluralKey;
    return t(key, { 0: count });
};
